import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../../core/redux/api/reduxStandardApiAction';
import { ACTION_TYPE } from '../../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../../core/redux/api/circuitBreaker/module';
import { IAppState } from '../../../core/redux/IAppState';
import { apiGetWaiverLookup } from '../../../core/redux/api/endpoints';
import ImmutableMap from '../../../language/ImmutableMap';
import { WaiverLookupApiItem } from './waiver';


const KEY_ACTION = ACTION_TYPE.GET_WAIVER_LOOKUP_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_WAIVER_LOOKUP_REQUEST,
  ACTION_TYPE.GET_WAIVER_LOOKUP_RESPONSE,
  ACTION_TYPE.GET_WAIVER_LOOKUP_ERROR,
];


/**
 * Constructs a Redux Action for retrieving waiver lookup
 */
export const waiverLookupAction = () => {
  return makeApiAction(
    {
      method:   'GET',
      endpoint: apiGetWaiverLookup(),
      headers:  (state: IAppState) => ({
        'content-type':  'application/json',
        'Authorization': `Bearer ${state.auth.bearerToken}`,
      }),
      types:    ACTIONS.map(action => ({ type: action })) as RsaaTypes,
      bailout:  state => !!getLoading(state, ACTION_TYPE.GET_WAIVER_LOOKUP_REQUEST, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
    },
  );
};


const reducer: ApiReducer<WaiverLookupApiItem[]> = (state, action, error, isLoading, payload): IAppState => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const adjustedState = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  const waiverLookup = (payload || []).reduce(
    (accumulator, it) => accumulator.add(`${it.waiverVersionId}`, it.waiverDescription),
    ImmutableMap.empty<string>(),
  );

  return {...adjustedState, waiverLookup};
};


export const waiverLookupReducer = makeApiReducer<WaiverLookupApiItem[]>(ACTIONS, KEY_ACTION, reducer);
